<template>
    <v-card
        color="transparent"
        outlined
    >
        <v-card-title class="d-flex justify-space-between">
            <span>Uppgifter</span>
            <v-btn
                color="primary"
                @click="createTask"
            >
                Skapa Uppgift
            </v-btn>
        </v-card-title>
        <v-data-table
            :items="tasks"
            :loading="loading"
            :headers="headers"
            :header-props="header_props"
            :server-items-length="total"
            :options.sync="options"
            @click:row="editTask"
            loading-text="Laddar..."
            hide-default-footer
        >
            <template #item.deadline="{ item }">
                {{ format_date(item.deadline) }}
            </template>
            <template #item.viewed_by_user="{ item }">
                {{ format_date_time(item.viewed_by_user) }}
            </template>
            <template #item.completed="{ item }">
                {{ format_date_time(item.completed) }}
            </template>
            <template #item._created="{ item }">
                <span :title="item._updated ? 'Uppdaterad: ' + format_date_time(item._updated) : ''">
                    {{ format_date(item._created) }}
                </span>
            </template>
            <template #footer>
                <v-divider/>
                <v-card-subtitle class="d-flex align-center justify-end">
                    <v-btn
                        @click="options.page -= 1"
                        :disabled="options.page === 1"
                        icon
                    >
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    {{ options.page }} / {{ pages }}
                    <v-btn
                        @click="options.page += 1"
                        :disabled="options.page === pages"
                        icon
                    >
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-card-subtitle>
            </template>
        </v-data-table>
        <TaskDetails
            v-model="show_dialog"
            :task="selectedTask"
            :user_id="user_id"
            @task-saved="load_data"
            @task-deleted="load_data"
            :key="dialogKey"
        />
    </v-card>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {api_mixin} from '@/mixins/services/api_mixin'
import {date_mixin} from '@/mixins/services/date_mixin'
import TaskDetails from '@/components/user/TaskDetails.vue'

export default {
    name: 'Tasks',
    props: {
        user_id: {
            type: String,
        },
    },
    mixins: [api_mixin, date_mixin],
    components: {TaskDetails},
    data() {
        return {
            loading: true,
            tasks: [],
            total: -1,
            header_props: {
                sortByText: 'Sortera',
            },
            headers: [
                {
                    text: 'Rubrik',
                    value: 'headline',
                },
                {
                    text: 'Deadline',
                    value: 'deadline',
                },
                {
                    text: 'Visad',
                    value: 'viewed_by_user',
                },
                {
                    text: 'Färdigställd',
                    value: 'completed',
                },
                {
                    text: 'Skapad',
                    value: '_created',
                },
            ],
            options: {
                sortBy: ['deadline'],
                sortDesc: [false],
                itemsPerPage: 20,
                page: 1,
                mustSort: true,
            },
            show_dialog: false,
            selectedTask: {},
            dialogKey: 0,
        }
    },
    computed: {
        pages() {
            const pages = Math.ceil(this.total / this.options.itemsPerPage)
            return pages <= 0 ? 1 : pages
        },
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {
        options: {
            handler() {
                this.load_data()
            },
            deep: true,
        },
    },
    methods: {
        async load_data() {
            this.loading = true
            const [sort_by] = this.options.sortBy
            const [sort_desc] = this.options.sortDesc
            const sort = sort_desc ? '-' + sort_by : '' + sort_by
            const max_results = this.options.itemsPerPage
            const page = this.options.page
            const result = await this.api_get({
                url: 'x-u2work--tasks',
                params: {
                    where: {
                        user: this.user_id,
                    },
                    projection: {
                        headline:1,
                        deadline: 1,
                        description: 1,
                        viewed_by_user: 1,
                        completed: 1,
                        user: 1,
                        _created: 1,
                        _updated: 1,
                    },
                    sort: sort,
                    max_results: max_results,
                    page: page,
                },
            })
            this.tasks = result.data['_items']
            this.total = result.data['_meta']['total']
            this.loading = false
        },
        editTask(task) {
            this.selectedTask = task
            this.dialogKey++
            this.show_dialog = true
        },
        createTask() {
            this.selectedTask = {}
            this.dialogKey++
            this.show_dialog = true
        },
        ...mapActions([]),
    },
    mounted() {
        this.load_data()
    },
}
</script>

<style scoped lang="sass">
::v-deep tbody tr:hover
    cursor: pointer
</style>
